import { SearchParams } from "./defs";

export const buildSearchRequest = (searchParams: SearchParams) => {
  const params: string[] = [];

  const addParameter = (paramName: string, paramValue: string | undefined) => {
    if (paramValue !== undefined && paramValue.trim() !== "") {
      params.push(`${paramName}=${paramValue}`);
    }
  };

  addParameter("phone", searchParams?.phone);
  addParameter("name", searchParams?.name);
  addParameter("page", searchParams?.page);

  return `q?${params.join("&")}`;
};
